export const tachesBasePath = 'taches';
export const listeDossierTachesPath = '/taches/dossiers';
export const listeTiersTachesPath = '/taches/prescripeurs';
export const listeUserTachesPath = '/taches/mes-taches';
